module.exports = __webpack_public_path__ + "static/media/solace-and-discovery.cdf23973.png";